
export default {
  methods: {
    matchingCellStyle({value, data}, compareValue) {
      return value !== compareValue ? 'text-danger' : '';
    },
    nonMatchingCellStyle({value, data}, compareValue) {
      return value === compareValue ? 'text-danger' : '';
    },
  }
}
